import React from 'react'

const ScrollableElementWrapper = ({children}) => (
    <div style={{ overflowX: "auto", width: "100%" }}>
        {children}
    </div>
);

export default ScrollableElementWrapper


// WEBPACK FOOTER //
// ./src/components/common/ScrollableElementWrapper.js